import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { BsLocaleService } from 'ngx-foundation';

import { SearchService } from '../_services/search.service';
import { API_REQUEST } from '../_models/request.model';
import { Profile } from '../_models/profile.model';
import { ProfileService } from '../_services/profiles.service';
import { EnvironmentService } from '../_services/environment.service';
import { AuthenticationService } from '../_services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.scss'],
  providers: [SearchService],
})
export class ReportesComponent implements OnInit {
  topTableIsEmpty: boolean;
  bottomTableIsEmpty: boolean;
  topTableHasBeenQueried: boolean;
  bottomTableHasBeenQueried: boolean;
  topTableLoading: boolean;
  bottomTableLoading: boolean;
  topTableError: boolean;
  bottomTableError: boolean;
  reqEmpresa: boolean;
  displayTable1: boolean;
  displayTable2: boolean;
  columnsClicked: number;
  rowsClicked: number;
  prevCol: number;
  prevRow: number;
  prevColId: string;
  prevRowId: string;
  column: string;
  row: string;
  minDate: string;
  maxDate: string;
  headers: string[];
  bsRangeValue: Date;
  columnList: CheckboxItem[];
  rowList: CheckboxItem[];
  topTable: Table;
  bottomTable: Table;
  public isCollapsed = false;
  currentProfile: Profile;
  profileSubscription: Subscription;

  topFilter1: string;
  topFilter2: string;
  topDateFrom: Date;
  topDateTo: Date;

  bottomFilter1: string;
  bottomFilter2: string;
  bottomDateFrom: Date;
  bottomDateTo: Date;

  constructor(
    private searchTool: SearchService,
    private profilesService: ProfileService,
    private localeService: BsLocaleService,
    private envService: EnvironmentService,
    private authService: AuthenticationService,
    private router: Router
  ) {
    this.localeService.use('es');
  }

  checkUserToken() {
    // let isTokenValid = false;
    this.authService.checkUserToken()
      .subscribe((response: any) => {

      },
      error => {

      });
  }

  ngOnInit() {
    this.checkUserToken();
    this.topTableIsEmpty = false;
    this.bottomTableIsEmpty = false;
    this.topTableHasBeenQueried = false;
    this.bottomTableHasBeenQueried = false;
    this.topTableLoading = false;
    this.bottomTableLoading = false;
    this.topTableError = false;
    this.bottomTableError = false;
    this.currentProfile = this.profilesService.getSelectedProfile();
    // Subscribe to user's profile change
    this.profileSubscription = this.profilesService.selectedProfileSubject.subscribe(
      (profile: Profile) => {
        this.currentProfile = profile;
      }
    );

    this.reqEmpresa = false;
    this.reqEmpresa = false;

    this.columnsClicked = 0;
    this.rowsClicked = 0;
    this.columnList = [];
    this.columnList.push(new CheckboxItem('Por Central', false));
    this.columnList.push(new CheckboxItem('Por Tipo de Afiliación', false));
    this.columnList.push(new CheckboxItem('Por Trámite', false));
    this.columnList.push(new CheckboxItem('Por Procedencia', false));
    this.columnList.push(new CheckboxItem('Por Estado', false));
    // this.columnList.push(new CheckboxItem('Por Novedad', false));

    this.rowList = [];

    this.rowList.push(new CheckboxItem('Por Empresa', false));
    this.rowList.push(new CheckboxItem('Por Central', false));
    this.rowList.push(new CheckboxItem('Por Tipo de Afiliación', false));
    this.rowList.push(new CheckboxItem('Por PAC', false));
    this.rowList.push(new CheckboxItem('Por Trámite', false));
    this.rowList.push(new CheckboxItem('Por Procedencia', false));
    this.rowList.push(new CheckboxItem('Por Estado', false));
    // this.rowList.push(new CheckboxItem('Por Novedad', false));

    this.column = '';
    this.row = '';
    this.prevCol = 0;
    this.prevRow = 0;
    this.bsRangeValue = undefined;
    this.topTable = new Table();
    this.bottomTable = new Table();
  }

  // FUNCION USADA PARA CONVERTIR LOS VALORES DEL MODAL EN VALORES ACEPTADOS POR EL WEB SERVICE DE REPORTES Y VICEVERSA
  // ENTRADA: value @string
  // SALIDA: @string correspondiente al value ingresado.
  translateFilter(value: string): string {
    this.reqEmpresa = false;
    switch (value) {
      case 'Por Empresa':
        this.reqEmpresa = true;
        return 'nombreAfiliado';
      case 'Por Central':
        return 'central';
      case 'Por Tipo de Afiliación':
        return 'tipoAfiliacion';
      case 'Por PAC':
        return 'pacs';
      case 'Por Trámite':
        return 'tipoTramite';
      case 'Por Procedencia':
        return 'procedencia';
      case 'Por Estado':
        return 'estado';
      case 'Por Novedad':
        return 'novedad';
      case 'empresa':
        return 'Por Empresa';
      case 'central':
        return 'Por Central';
      case 'tipoAfiliacion':
        return 'Por Tipo de Afiliación';
      case 'pacs':
        return 'Por PAC';
      case 'tipoTramite':
        return 'Por Trámite';
      case 'procedencia':
        return 'Por Procedencia';
      case 'estado':
        return 'Por Estado';
      case 'novedad':
        return 'Por Novedad';
      default:
        return '';
    }
  }

  // SE VALIDA QUE SOLO SE PUEDA SELECCIONAR UN FILTRO CORRESPONDIENTE A LAS COLUMNAS DE LA TABLA
  updateColumnSelection(evt, index: number): void {
    if (
      this.translateFilter(this.columnList[index].display) !== this.column ||
      this.column === ''
    ) {
      if (this.translateFilter(this.row) !== this.columnList[index].display) {
        if (this.prevCol !== 0) {
          (<HTMLInputElement>(
            document.getElementById(this.prevColId)
          )).checked = false;
        }
        this.prevCol = index + 1;
        this.prevColId = evt.target.id;
      } else {
        (<HTMLInputElement>(
          document.getElementById(evt.target.id)
        )).checked = false;
      }
      if (evt.target.checked) {
        if (this.columnsClicked === 0) {
          this.column = this.translateFilter(this.columnList[index].display);
        }
      }
      this.columnList[index].enabled = evt.target.checked;
    } else {
      this.column = '';
      this.prevCol = 0;
      this.prevColId = '';
    }
  }

  // SE VALIDA QUE SOLO SE PUEDA SELECCIONAR UN FILTRO CORRESPONDIENTE A LAS FILAS DE LA TABLA
  updateRowSelection(evt, index: number): void {
    if (
      this.translateFilter(this.rowList[index].display) !== this.row ||
      this.row === ''
    ) {
      if (this.translateFilter(this.column) !== this.rowList[index].display) {
        if (this.prevRow !== 0) {
          (<HTMLInputElement>(
            document.getElementById(this.prevRowId)
          )).checked = false;
        }
        this.prevRow = index + 1;
        this.prevRowId = evt.target.id;
      } else {
        (document.getElementById(
          evt.target.id
        ) as HTMLInputElement).checked = false;
      }
      if (evt.target.checked) {
        if (this.rowsClicked === 0) {
          this.row = this.translateFilter(this.rowList[index].display);
        }
      }
      this.rowList[index].enabled = evt.target.checked;
    } else {
      this.row = '';
      this.prevRow = 0;
      this.prevRowId = '';
    }
  }

  //SE SEPARAN LAS FECHAS DEL RANGE DATE PICKER EN 2 VARIABLES.
  updateDates(): void {
    let minDateVar: Date;
    let maxDateVar: Date;
    minDateVar = new Date(this.bsRangeValue.toString().split(',')[0]);
    maxDateVar = new Date(this.bsRangeValue.toString().split(',')[1]);

    this.minDate = minDateVar.toISOString();
    this.maxDate = maxDateVar.toISOString();
  }

  //SE CARGA EL FILTRO CORRESPONDIENTE DEPENDIENDO DE SI ES UNA FILA O COLUMNA
  //PARA LAS EMPRESAS SE VALIDA ADICIONALMENTE DE QUE EL TIPO DE IDENTIFICACION SEA NIT 
  loadArray(type: string, res: API_REQUEST): string[] {
    let response: string[] = [];
    if (type === 'column') {
      for (let row: number = 0; row < res.responseObject.length; row++) {
        if (this.reqEmpresa) {
          if (res.responseObject[row][2].valorColumna === 'NIT') {
            response.push(res.responseObject[row][0].valorColumna);
          }
        } else {
          response.push(res.responseObject[row][0].valorColumna);
        }
      }
      return response;
    } else if (type === 'row') {
      for (let row: number = 0; row < res.responseObject.length; row++) {
        if (this.reqEmpresa) {
          if (res.responseObject[row][2].valorColumna === 'NIT') {
            response.push(res.responseObject[row][1].valorColumna);
          }
        } else {
          response.push(res.responseObject[row][1].valorColumna);
        }
      }
      return response;
    } else {
      return response;
    }
  }

  loadCell(row: string, col: string, data: API_REQUEST): number {
    let response = 0;
    let con = 0;
    // SE BUSCAN LAS COINCIDENCIAS REPETIDAS DE LA CONSULTA.
    for (let row_index: number = 0; row_index < data.responseObject.length; row_index++) {
      con++;
      if (col === data.responseObject[row_index][0].valorColumna && row === data.responseObject[row_index][1].valorColumna) {
        response += parseInt(data.responseObject[row_index][data.responseObject[row_index].length - 1].valorColumna);
      }
    }
    return response;
  }


  // FUNCION QUE SE ENCARGAR DE LLENAR LA PRIMERA TABLA
  fillTopTable(): void {
    let hasRow: boolean = false;
    let hasCol: boolean = false;
    this.topTableLoading = true;
    this.topTableError = false;
    this.topTableHasBeenQueried = true;
    // SE VALIDA QUE SE HAYAN ESCOGIDO LAS FECHAS PARA COLOCARLAS EN EL FORMATO CORRECTO
    if (this.bsRangeValue !== undefined) {
      this.updateDates();
    }

    if (this.minDate && this.maxDate) {
      // Update Title Values
      this.topFilter1 = this.column;
      this.topFilter2 = this.row;
      this.topDateFrom = new Date(this.minDate);
      this.topDateTo = new Date(this.maxDate);
      let cols = [];
      if (this.column.length > 0) {
        cols.push(this.column);
        hasCol = true;
      }
      if (this.row.length > 0) {
        cols.push(this.row);
        hasRow = true;
      }
      if (this.reqEmpresa) {
        cols.push('tipoIdentificacion');
        cols.push('identificacion');
      }
      //SE HACE LA BUSQUEDA
      this.searchTool
        .search_all({
          fechaInicial: this.minDate,
          fechaFinal: this.maxDate,
          columnas: cols,
        })
        .subscribe(
          response => {
            //SE REINICIAN LAS OPCIONES DE CARGUE Y ERROR.
            this.topTableLoading = false;
            this.topTableError = false;
            //LA TABLA ESTA VACIA
            if (response.responseObject.length === 0) {
              this.topTableIsEmpty = true;
            } else {
              this.topTableIsEmpty = false;
            }
            //SE FILTRAN LOS ELEMENTOS REPETIDOS DE LA CONSULTA EN FILAS Y COLUMNAS
            let temp_cols = this.loadArray('column', response);
            let col_u = temp_cols.filter((v, i, s) => s.indexOf(v) === i);
            let temp_rows = this.loadArray('row', response);
            let row_u = temp_rows.filter((v, i, s) => s.indexOf(v) === i);
            //SE CREA LA TABLA
            if (hasCol != hasRow) {
              //SE SELECCIONO UN SOLO FILTRO
              this.topTable.table = new Array(1);
              this.topTable.table[0] = new Array(col_u.length);
              for (let col = 0; col < col_u.length; col++) {
                this.topTable.table[0][col] = response.responseObject[col][1].valorColumna;
              }
              this.topTable.headers = col_u;
            } else {
              //SE USAN AMBOS FILTROS
              this.topTable.table = new Array(row_u.length);
              //SE LLENA LA TABLA
              for (let row = 0; row < row_u.length; row++) {
                this.topTable.table[row] = new Array(col_u.length + 1);
                //SE INSERTA EL FILTRO DE LA FILA
                this.topTable.table[row][0] = row_u[row];
                for (let column = 0; column < col_u.length; column++) {
                  //SE AÑADE LA CELDA
                  this.topTable.table[row][column + 1] = this.loadCell(
                    row_u[row],
                    col_u[column],
                    response
                  ).toString();
                }
              }
              let temp = [];

              temp.push(this.row);
              //SE AÑADEN LOS TITULOS DE LAS COLUMNAS DE LA TABLA
              this.topTable.headers = temp.concat(col_u);
            }

            this.topTable.visible = true;
          },
          error => {
            this.topTableLoading = false;
            this.topTableError = true;
            this.topTableIsEmpty = true;
            const errorObject = error as HttpErrorResponse;
            if (errorObject.status === 401) {
              this.authService.logout();
              this.router.navigate(['/logout']);
              // const logBackURL = this.envService.cafamLoginURL + this.envService.appReturnURL;
              // location.replace(logBackURL);
            }
          }
        );
    }
  }

  fillBottomTable(): void {
    let hasRow: boolean = false;
    let hasCol: boolean = false;
    //SE REINICIAN LAS OPCIONES DE CARGUE Y ERROR.
    this.bottomTableLoading = true;
    this.bottomTableError = false;
    this.bottomTableHasBeenQueried = true;
    this.bottomTableHasBeenQueried = true;
    if (this.bsRangeValue !== undefined) {
      this.updateDates();
    }
    if (this.minDate && this.maxDate) {
      // Update Title Values
      this.bottomFilter1 = this.column;
      this.bottomFilter2 = this.row;
      this.bottomDateFrom = new Date(this.minDate);
      this.bottomDateTo = new Date(this.maxDate);

      let cols = [];
      if (this.column.length > 0) {
        cols.push(this.column);
        hasCol = true;
      }
      if (this.row.length > 0) {
        cols.push(this.row);
        hasRow = true;
      }
      if (this.reqEmpresa) {
        cols.push('tipoIdentificacion');
        cols.push('identificacion');
      }
      //SE HACE LA BUSQUEDA
      this.searchTool
        .search_all({
          fechaInicial: this.minDate,
          fechaFinal: this.maxDate,
          columnas: cols,
        })
        .subscribe(
          response => {
            //SE REINICIAN LAS OPCIONES DE CARGUE Y ERROR.
            this.bottomTableLoading = false;
            this.bottomTableError = false;
            //LA TABLA ESTA VACIA
            if (response.responseObject.length == 0) {
              this.bottomTableIsEmpty = true;
            } else {
              this.bottomTableIsEmpty = false;
            }
            //SE FILTRAN LOS ELEMENTOS REPETIDOS DE LA CONSULTA EN FILAS Y COLUMNAS
            let temp_cols = this.loadArray('column', response);
            let col_u = temp_cols.filter((v, i, s) => s.indexOf(v) === i);
            let temp_rows = this.loadArray('row', response);
            let row_u = temp_rows.filter((v, i, s) => s.indexOf(v) === i);
            //SE CREA LA TABLA
            this.bottomTable.table = new Array(row_u.length);
            //SE LLENA LA TABLA
            if (hasCol != hasRow) {
              //SE SELECCIONO UN SOLO FILTRO
              this.bottomTable.table = new Array(1);
              this.bottomTable.table[0] = new Array(col_u.length);
              for (let col = 0; col < col_u.length; col++) {
                this.bottomTable.table[0][col] = response.responseObject[col][1].valorColumna;
              }
              //console.log(col_u);
              this.bottomTable.headers = col_u;
            } else {
              //SE USAN AMBOS FILTROS
              for (let row = 0; row < row_u.length; row++) {
                this.bottomTable.table[row] = new Array(col_u.length + 1);
                //SE INSERTA EL FILTRO DE LA FILA
                this.bottomTable.table[row][0] = row_u[row];
                for (let column = 0; column < col_u.length; column++) {
                  //SE AÑADE LA CELDA
                  this.bottomTable.table[row][column + 1] = this.loadCell(
                    row_u[row],
                    col_u[column],
                    response
                  ).toString();
                }
              }
              let temp = [];
              temp.push(this.row);
              //SE AÑADEN LOS TITULOS DE LAS COLUMNAS DE LA TABLA
              this.bottomTable.headers = temp.concat(col_u);
            }

            this.bottomTable.visible = true;
          },
          error => {
            this.bottomTableLoading = false;
            this.bottomTableError = true;
            this.bottomTableIsEmpty = true;
            const errorObject = error as HttpErrorResponse;
            if (errorObject.status === 401) {
              this.authService.logout();
              this.router.navigate(['/logout']);
              // const logBackURL = this.envService.cafamLoginURL + this.envService.appReturnURL;
              // location.replace(logBackURL);
            }
          }
        );
    }
  }
}

class CheckboxItem {
  display = '';
  enabled = false;

  constructor(display: string, enabled: boolean) {
    this.display = display;
    this.enabled = enabled;
  }
}

class Table {
  visible: boolean;
  headers: string[];
  table: string[][];

  constructor() {
    this.visible = false;
    this.headers = [];
    this.table = [];
  }
}
